export default __webpack_public_path__ + "static/media/thumbnail-w-chair@3x.67fe6a99.png";